<template>
  <div>
    <!-- <j-title-header :options="opsi"/> -->
    <div v-show="load_first">

      <!-- <b-row>
        <b-col cols="9">
          <div class="float-to-left">
            <jImportFlows @upload-done="uploadDone"/>
          </div>
          <div>
            <div class="float-to-left">
              <jExportFlows class="m__t--20" />
            </div>
          </div>

        </b-col>

        <b-col>
          <div class="create-flow">
            <b-button
              class="btn blue"
              @click="createFlow">CREATE FLOW</b-button>
          </div>
        </b-col>
      </b-row> -->

      <v-server-table
        ref="flowServer"
        :url="env"
        :columns="columns"
        :options="options"
        class="jTable"
        @loading="loading"
        @loaded="loaded"
        @row-click="rowClick"
        @pagination="removeRowBackground">

        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form
            inline
            @keypress.13.prevent="filter(filter_data)">
            <b-button
              class="btn grey btn-import-form m__r--5"
              @click="createFlow">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
            <j-select
              v-model="select_type"
              :disabled="false"
              :options="options_search"
              class="m__r--5"/>
            <b-form-input
              ref="filterInput"
              v-model="filter_data"
              placeholder="search"
              class="m__r--5"/>
            <b-button
              class="btn grey btn-import-form m__r--10"
              @click="filter(filter_data)">
              <i class="fa fa-search bold" /> Search
            </b-button>
            <jImportFlows @upload-done="uploadDone"/>
          </b-form>
          <!-- <b-row>
            <b-col cols="7">
              <b-form
                @keyup.enter="filter(filter_data)">
                <b-form-group>
                  <j-input
                    v-model="filter_data"/>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col
              class="p--1 p__l--2"
              style="align-self: center;"
              cols="5">
              <b-button
                class="btn blue outline"
                @click="filter(filter_data)"> <i class="fa fa-search bold" /> Search </b-button>
            </b-col>
          </b-row> -->
        </div>

        <!-- <div
          slot="flow"
          slot-scope="props"
          class="flow-list"> -->
        <!-- :class="flowRowClass(index, props.index-1)"> -->
        <!-- :class="{'light-blue-flow' : index % 2 === 0}"
        class="flow-table flow-arrow"> -->
        <!-- <div
            v-for="(flow, index) in props.row.members"
            :key="index"
            :class="{'light-blue-flow' : index % 2 === 0}"
            class="flow-table flow-arrow"> -->
        <!-- :class="flowRowClass(index, props.index-1)"> -->
        <!-- <i
              v-if="index === 0"
              class="fa fa-square"/>
            {{ flow.order }} -->
        <!-- <div v-else-if="stop[props.index-1] !== null">
            <div v-if="(stop[props.index-1]-2) === index">
              ...
            </div>
            <div v-else-if="stop[props.index-1]-1 <= index"/>
            <div v-else>
              {{ flow.order }}
            </div>
          </div>
          <div v-else>
            {{ flow.order }}
          </div> -->
        <!-- </div> -->
        <!-- </div> -->
        <div
          slot="created_date"
          slot-scope="props">
          {{ props.row.created_date | moment("DD/MM/YYYY") }}
        </div>

        <div
          slot="type_name"
          slot-scope="props">
          {{ props.row.type === 1 ? 'ORDER' : '' }}
          {{ props.row.type === 2 ? 'NO ORDER' : '' }}
          {{ props.row.type === 3 ? 'MIN' : '' }}
          {{ props.row.minimum_action !== 0 ? props.row.minimum_action : '' }}
        </div>

      </v-server-table>
    </div>

    <b-modal
      ref="createFlow"
      class="mod-form"
      centered
      no-close-on-esc>
      <div class="float-to-center p--20">
        <b-button
          class="btn blue m__r--20"
          @click="$router.replace('/flow/new')">
          Create Flow Default
        </b-button>
        <b-button
          class="btn blue outline"
          @click="$router.replace('/flow/new-by-division')">
          Create Flow By Division
        </b-button>
      </div>
    </b-modal>

    <div
      v-if="!load_first">
      <jLoadingTable/>
    </div>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex';
import { jFlow } from '@/mixins/components/jojoflow/jFlow';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
// import jExportFlows from './jExportFlows';
import jImportFlows from './jImportFlows';

export default {
  // eslint-disable-next-line
  name: 'jFlow',
  components: {
    jLoadingTable,
    // jExportFlows,
    jImportFlows,
  },
  mixins: [jFlow],
  data() {
    return {
      // stop: [null],
      rowing: null,
      opsi: {
        icon: 'fa-user',
        main_title: 'FLOWS',
        opt_title: '',
      },
    };
  },
  computed: {
    ...mapState('jStoreFlows', ['flows_table', 'manage_flow']),
    ...mapState('jStoreRules', ['upload_rules_finished']),
  },
  watch: {
    rowing(newData, oldData) {
      if (oldData) {
        this.removeRowClick(oldData);
      }
    },

    upload_rules_finished() {
      this.refreshTable();
    },

    // eslint-disable-next-line
    'manage_flow.is_open': function() {
      this.removeRowBackground();
      this.removeRowClick();
    },

    load_first(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.filterInput.focus();
        }, 200);
      }
    },
    // flows_table() {
    //   const widthFlow = document.querySelector
    // (`.row-${this.flows_table[0].id}`).childNodes[3].offsetWidth;
    //   for (let x = 0; x < this.flows_table.length; x++) {
    //     let total = 0;
    //     if (document.querySelector(`.row-${this.flows_table[x].id}`)) {
    //       const flowList = document.querySelector(`.row-$
    // {this.flows_table[x].id} .flow-list`);
    //       for (let i = 0; i < flowList.childNodes.length; i++) {
    //         // console.log(`ke sini ${x}`);
    //         const EachFlow = flowList.childNodes[i].offsetWidth;
    //         total += EachFlow;
    //         if (total + 50 > widthFlow) {
    //           if (this.stop[x] === null) {
    //             // console.log(`ke sini 3a ${i}`);
    //             this.stop.splice(x, 1, i);
    //             if (document.querySelector
    // (`.row-${this.flows_table[x + 1].id}`)) {
    //               this.stop.push(null);
    //             }
    //           }
    //         }
    //       }
    //       if (this.stop[x] === null &&
    // document.querySelector(`.row-${this.flows_table[x + 1].id}`)) {
    //         this.stop.push(null);
    //       }
    //     }
    //   }
    // },
  },
  created() {
    // this.getListFlow();
  },
  methods: {
    ...mapActions('jStoreFlows', ['getListFlow']),

    createFlow() {
      this.$refs.createFlow.show();
    },

    uploadDone() {
      this.refreshTable();
    },

    rowClick(data) {
      const elem = document.getElementsByClassName(`row-${data.row.id}`);
      elem[0].setAttribute('style', 'background-color: #b3e8f8;');
      elem[0].classList.add('mystyle');
      this.rowing = data.row.id;
      const dataa = data;
      const isCreatedByDivision = dataa.row.create_by_division
        ? dataa.row.create_by_division : false;
      dataa.row.create_by_division = isCreatedByDivision;
      this.$emit('row-click', data);
      this.$store.commit('jStoreFlows/setFlowData', data);
    },
    removeRowClick(data) {
      const elem = document.getElementsByClassName(`row-${data}`);
      if (elem.length === 1) {
        elem[0].setAttribute('style', 'background-color: none;');
      }
    },
    removeRowBackground() {
      if (this.rowing) {
        const elem = document.getElementsByClassName(`row-${this.rowing}`);
        if (elem.length === 1) {
          elem[0].setAttribute('style', 'background-color: none;');
        }
      }
      this.rowing = null;
      this.$emit('pagination');
      // this.$store.commit('jFlows/setFlowData', null);
    },

    refreshTable() {
      this.$refs.flowServer.getData();
    },
  },
};
</script>

<style lang="scss">
  .jImportFile .xlsx-button {
    width: 150px !important;
    margin: 0px 0px 0px -3px !important;
  }
  .jImportFile .icon.btn-secondary {
    padding: 6px 5px !important;
    width: 50px !important;
  }
  .jImportFile .icon.btn-secondary i:before {
    right: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/flow-rule/flow/flow-non-sla/jFlow.vue